import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import TourV2BookWithConfidenceItem from './TourV2BookWithConfidenceItem'
import Group from 'components/utils/Group'
import useTourLabels from 'hooks/Tours/useTourLabels'

function TourV2BookWithConfidence() {
  const { tourV2BookWithConfidenceItems } = useTourLabels()

  return (
    <Group direction="vertical" gap={16}>
      <Heading variant="heading3" align="center">
        <FormattedMessage
          id="kkr9RfnxvIsyxOf8f0cU"
          defaultMessage="Book with confidence"
          description="Heading for the book with confidence section on tour offer page"
        />
      </Heading>
      <Group direction="vertical" gap={24} desktopDirection="horizontal" desktopGap={0}>
        {tourV2BookWithConfidenceItems.map(item => (
          <TourV2BookWithConfidenceItem
            key={item.title}
            {...item}
          />
        ))}
      </Group>
    </Group>
  )
}

export default TourV2BookWithConfidence
